import { useState, useEffect } from "react";
import { Box, Typography, TextField, Divider } from "@mui/material";
import { UseSellReport } from "./UseSellReport";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CategoryReport from "./CategoryReport";
import BrandReport from "./BrandReport";
import GroupReport from "./GroupReport";
import ProductReport from "./ProductReport";
import DetailPopUp from "./DetailPopUp";
import { useLocation } from "react-router-dom";

export default function SellReport(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [productDetail, setProductDetail] = useState();
  const [detailShow, setDetailShow] = useState({ show: false });
  const { GetSellReport, GetItemReport } = UseSellReport();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [expanded, setExpanded] = useState();

  useEffect(() => {
    GetSellReport(true);
  }, []);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Detail
      breadChilds={{
        // backButtonDef: {
        //   state: location.state,
        //   replace: true,
        // },
        // backURL: "/ordersreport",
        title: "گزارشات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/productreport" }],
      }}
    >
      {productDetail && (
        <DetailPopUp
          detailShow={detailShow}
          setDetailShow={setDetailShow}
          productDetail={productDetail}
        />
      )}
      <CategoryReport
        expanded={expanded}
        setExpanded={setExpanded}
        // handleChange={(panel) => handleChange(panel)}
        callback={(callback) => {
          setProgress(true);
          GetItemReport(callback, (resauls) => {
            setProgress(false);
            setProductDetail(resauls);
            setDetailShow({ show: true });
          });
        }}
      ></CategoryReport>
      <BrandReport
        expanded={expanded}
        setExpanded={setExpanded}
        callback={(callback) => {
          setProgress(true);
          GetItemReport(callback, (resauls) => {
            setProgress(false);
            setProductDetail(resauls);
            setDetailShow({ show: true });
          });
        }}
      ></BrandReport>
      <GroupReport
        expanded={expanded}
        setExpanded={setExpanded}
        callback={(callback) => {
          setProgress(true);
          GetItemReport(callback, (resauls) => {
            setProgress(false);
            setProductDetail(resauls);
            setDetailShow({ show: true });
          });
        }}
      ></GroupReport>
      <ProductReport
        expanded={expanded}
        setExpanded={setExpanded}
        detailShow={detailShow}
        setDetailShow={setDetailShow}
        productDetail={productDetail}
        setProductDetail={setProductDetail}
      ></ProductReport>
    </Detail>
  );
}
